<template>
    <div>
        <b-card border-variant="dark" class="mt-4">
            <div class="height-queue">
                <div id="table-header" class="row">
                    <h4 class="col-4"><i class="fas fa-phone"></i> CHAMADAS</h4>
                    <input type="text" class="form-control col-4" v-model="searchInput" placeholder="Pesquisar">
                    <select class="form-control col-3" v-model="attFilter" style="flex: 1">
                        <option value="*">Todas as filas</option>
                        <option v-for="queue in queues" :value="queue.name" :key="queue.id">{{ queue.name }}</option>
                    </select>
                </div>

                <b-table id="tbDetails" small striped bordered fixed head-variant="dark" :hover="true"
                    :per-page="perPage" :fields="fields" :items="getCalls" responsive="sm" class="mt-2"
                    :current-page="currentPage" show-empty>
                    <template #empty="scope">
                        <h6 class="text-center">NENHUMA CHAMADA EM CURSO</h6>
                    </template>
                </b-table>

                <strong>
                    <span>Total de {{ items.length }} chamadas</span>
                </strong>

                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                    aria-controls="tbDetails" size="sm" align="right">
                </b-pagination>
            </div>
        </b-card>
    </div>
</template>

<script>
String.prototype.toHHMMSS = function () {
    var sec_num = parseInt(this, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);
    if (hours < 10) { hours = "0" + hours; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
    return hours + ':' + minutes + ':' + seconds;
}

String.prototype.toSeconds = function () {
    if (!this.match(/\d{2}:\d{2}:\d{2}/g)) return 'Bad foramt';
    let hhmmss = this.split(':');
    let hour = Math.floor(parseInt(hhmmss[0]) * 3600);
    let minutes = Math.floor(parseInt(hhmmss[1]) * 60);
    let seconds = parseInt(hhmmss[2]);
    return hour + minutes + seconds;
}

export default {
    name: "RealtimeCallDetailsTable",
    props: ["conSocket"],
    data() {
        return {
            fields: [
                { key: 'uniqueid', label: 'ID', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'origin', label: 'NÚMERO', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'status', label: 'STATUS', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'agent', label: 'USUARIO', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'queue', label: 'FILA', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'time', label: 'TEMPO DE STATUS', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
                { key: 'totalTime', label: 'TEMPO TOTAL', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
            ],
            calls: [],
            currentPage: 1,
            perPage: 10,
            queues: [],
            users: [],
            attFilter: '*',
            searchInput: '',
            items: [],
            users: [],
            intervalTimer: null,
        }
    },
    methods: {
        calcTimer() {
            clearInterval(this.intervalTimer);
            this.intervalTimer = setInterval(() => {
                this.items = this.items.map((el) => {
                    let tempo = el.time.toSeconds();
                    let tempoTotal = el.totalTime.toSeconds();
                    tempo++;
                    tempoTotal++;
                    el.time = tempo.toString().toHHMMSS();
                    el.totalTime = tempoTotal.toString().toHHMMSS();
                    return el;
                });
            }, 1000);
        },
        getUsers() {
            axios.get('/realtime/listUsersPhone')
                .then(({ data }) => {
                    if (data) this.users = data.map(el => {
                        const first = el.nome.split(" ")[0];
                        return {
                            "name": first,
                            "exten": el.extension_line,
                            "nameExten": `${first} (${el.extension_line})`,
                        }
                    });
                });
        },
        getQueues() {
            axios.get('/listQueue')
                .then(({ data }) => {
                    if (data) this.queues = data;
                });
        },
        getTime(time) {
            if (time == NaN) return;
            let horas = ("00" + parseInt(time / 3600)).slice(-2);
            time = time - (horas * 3600);
            let minutos = ("00" + parseInt(time / 60)).slice(-2);
            time = time - (minutos * 60);
            let segundos = ("00" + parseInt(time)).slice(-2);
            const format = `${horas}:${minutos}:${segundos}`;
            if (parseInt(horas) < 1 && parseInt(minutos) < 30) {
                return { val: format, variant: 'success' };
            } else if (parseInt(horas) < 3) {
                return { val: format, variant: 'warning' };
            } else if (parseInt(horas) > 2) {
                return { val: format, variant: 'danger' };
            }
        },
        addItem(newData) {
            if (!newData.uniqueid) return;
            if (newData.agent) {
                const crtUser = this.users.find(el => el.exten == newData.agent);
                newData.agent = crtUser ? crtUser.nameExten : newData.agent;
            }
            const foundItem = this.items.findIndex(el => el.uniqueid == newData.uniqueid);
            if (foundItem >= 0) {
                this.items[foundItem] = newData;
            } else {
                this.items.push(newData);
            }
        },
        removeItem(uniqueid) {
            this.items = this.items.filter(el => el.uniqueid != uniqueid);
        },
        listenCoreShowChannel() {
            this.conSocket.on("CoreShowChannel", (data) => {
                let origin = data.Details.length == 1 ? data.Details[0] : data.Details[1];
                if(data.Details.includes("ramal")){
                    origin = data.Details[1];
                }
                const status = data.State.includes("Ring") ? "Tocando" : "Ligação";
                const cellColor = data.State.includes("Ring") ? "danger" : "success";
                const queue = data.Details.length > 1 ? data.Details[0] : "";
                const agent = data.Extension != "<unknown>" ? data.Extension : "";
                const newData = {
                    uniqueid: data.Uniqueid,
                    origin: origin,
                    status: status,
                    queue: this.getQueueAlias(queue),
                    // queue: queue,
                    agent: agent,
                    time: data.Time.toString().toHHMMSS(),
                    totalTime: data.StartTime.toString().toHHMMSS(),
                    _cellVariants: { status: cellColor },
                };

                this.addItem(newData);
            });
        },
        listenNewConnectedLine() {
            this.conSocket.on("NewConnectedLine", (data) => {
                let status = "Ligação";
                let cellColor = "success";
                const agent = data.Extension != "<unknown>" ? data.Extension : "";
                if (data.State.includes("Ring")) {
                    status = "Tocando";
                    cellColor = "danger";
                }

                const newData = {
                    uniqueid: data.Uniqueid,
                    origin: data.Number,
                    status: status,
                    queue: this.getQueueAlias(data.Queue),
                    // queue: data.Queue,
                    agent: agent,
                    time: data.Time.toString().toHHMMSS(),
                    totalTime: data.StartTime.toString().toHHMMSS(),
                    _cellVariants: { status: cellColor },
                }

                this.addItem(newData);
            });
        },
        listenCoreShowUra() {
            this.conSocket.on("CoreShowUra", (data) => {
                const stepUra = data.Application[1] || data.Application[0];
                const newData = {
                    uniqueid: data.Uniqueid,
                    origin: data.Number,
                    status: "URA",
                    queue: this.getQueueAlias(stepUra),
                    // queue: stepUra,
                    agent: "",
                    time: data.Time.toString().toHHMMSS(),
                    totalTime: data.Duration,
                    _cellVariants: { status: "primary" },
                }

                this.addItem(newData);
            });
        },
        listenNewchannel() {
            this.conSocket.on("NewchannelRealtimeTable", (data) => {
                const number = data.CallerIDNum != "<unknown>" ? data.CallerIDNum : "";
                const newData = {
                    uniqueid: data.Linkedid,
                    origin: number,
                    status: "URA",
                    queue: "Entrada",
                    agent: "",
                    time: data.time.toString().toHHMMSS(),
                    totalTime: data.startTime.toString().toHHMMSS(),
                    _cellVariants: { status: "primary" },
                }

                this.addItem(newData);
            });
        },
        listenNewExten() {
            this.conSocket.on("NewextenRealtimeTable", (data) => {
                const newData = {
                    uniqueid: data.uniqueid,
                    origin: data.caller,
                    status: "URA",
                    queue: this.getQueueAlias(data.queue),
                    // queue: data.queue,
                    agent: "",
                    time: data.time.toString().toHHMMSS(),
                    totalTime: data.startTime.toString().toHHMMSS(),
                    _cellVariants: { status: "primary" },
                }

                this.addItem(newData);
            });
        },
        listenQueueEntry() {
            this.conSocket.on("QueueEntryRealtimeTable", (data) => {
                const newData = {
                    uniqueid: data.Uniqueid,
                    origin: data.CallerIDNum,
                    status: "Aguardando",
                    queue: this.getQueueAlias(data.Queue),
                    // queue: data.Queue,
                    agent: "",
                    time: "00:00:00",
                    totalTime: data.Wait.toHHMMSS(),
                    _cellVariants: { status: "warning" },
                }

                this.addItem(newData);
            });
        },
        listenQueueCallerJoin() {
            this.conSocket.on("QueueCallerJoinRealtimeTable", (data) => {
                const newData = {
                    uniqueid: data.Linkedid,
                    origin: data.CallerIDNum,
                    status: "Aguardando",
                    queue: this.getQueueAlias(data.Queue),
                    // queue: data.Queue,
                    agent: "",
                    time: "00:00:00",
                    totalTime: "00:00:00",
                    _cellVariants: { status: "warning" },
                }

                this.addItem(newData);
            });
        },
        listenQueueCallerLeave() {
            this.conSocket.on("QueueCallerLeaveRealtimeTable", (data) => {
                this.removeItem(data.Linkedid);
            });
        },
        listenHangup() {
            this.conSocket.on("Hangup", (data) => {
                this.removeItem(data.Linkedid);
            });
        },
        getQueueAlias(queuename = '---'){
            if(this.queues.length){
              const find = this.queues.find(el => el.name === queuename)
              if (find?.alias) return find.alias;
            }
            return queuename
        }
    },
    computed: {
        rows() {
            return this.items.length;
        },
        getCalls() {
            let resultFilter = this.items;
            let keyword = this.searchInput?.toLowerCase();
            let queueFilter = this.attFilter?.toLowerCase();
            if (this.attFilter != "*") {
                resultFilter = resultFilter.filter(el => {
                    const queue = el.queue?.toLowerCase();
                    return queue?.includes(queueFilter);
                });
            }

            return resultFilter.filter(el => {
                const queue = el.queue?.toLowerCase();
                const phone = el.phone?.toLowerCase();
                const status = el.status?.toLowerCase();
                const agent = el.agent?.toLowerCase();
                const { uniqueid, origin, } = el;
                return (queue?.includes(keyword) ||
                    phone?.includes(keyword) ||
                    status?.includes(keyword) ||
                    agent?.includes(keyword) ||
                    uniqueid?.includes(keyword) ||
                    origin?.includes(keyword)
                );
            })
        },
    },
    created() {
        this.getUsers();
        this.getQueues();
    },
    mounted() {
        this.listenCoreShowChannel();
        this.listenNewConnectedLine();
        this.listenCoreShowUra();
        this.listenNewchannel();
        this.listenNewExten();
        this.listenQueueEntry();
        this.listenQueueCallerJoin();
        this.listenQueueCallerLeave();
        this.listenHangup();
    },
    watch: {
        items(value) {
            if (!Number.isInteger(this.intervalTimer) && value.length > 0) {
                this.calcTimer();
                return
            }

            if (value.length <= 0) {
                clearInterval(this.intervalTimer);
                this.intervalTimer = null;
            }
        },
        users(value) {
            this.items.forEach(item => {
                if (item.agent) {
                    const crtUser = value.find(el => el.exten == item.agent);
                    item.agent = crtUser ? crtUser.nameExten : item.agent;
                };
            })
        }
    }
}
</script>

<style scoped>
#table-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: black;
}

.card {
    color: black !important;
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
    border-radius: 0.25rem !important;
}

.font-15 {
    font-size: 15px;
}

#action-button-view {
    cursor: pointer;
    font-size: 16px;
    color: #1c869a;
    transition: 0.25s;
    margin: 5px;
}

#action-button-view:hover {
    color: #177081;
}

#action-button-delete {
    cursor: pointer;
    font-size: 16px;
    color: #e3342f;
    transition: 0.25s;
    margin: 5px;
}

#action-button-delete:hover {
    color: #b42a26;
}
</style>